/**
 * 贝恩页面api
 */
const beadmin = {
  getEventStatisticsNumByLevel: "/api/getEventStatisticsNumByLevel", //根据等级统计告警
  getEventStatisticsNumByCode: "/api/getEventStatisticsNumByCode", //根据告警类型统计告警
  getEventStatisticsNumByType: "/api/getEventStatisticsNumByType", //根据告警类型统计告警
  getEnergyEfficiencyBenchmark: "/api/tmp/beien/getEnergyEfficiencyBenchmark",
  peekReport: "/api/peekReport", //获取用能体检报告
  getExpensesOfUse: "/api/tmp/beien/getExpensesOfUse", //获取成本费用
  getBenchmarkKPI: '/api/tmp/beien/getBenchmarkKPI',//4、能效对标本地、行业对标值
};

export default beadmin;
